const initAnnouncementBar = () => {
    const announcementBar = document.getElementById('announcementBar');
    const closeButton = announcementBar?.querySelector('.announcement-close');

    if (announcementBar && closeButton) {
        // Prüfen ob der Störer bereits in dieser Session geschlossen wurde
        if (!sessionStorage.getItem('announcementBarClosed')) {
            // Zeige den Störer an, wenn er noch nicht geschlossen wurde
            announcementBar.classList.add('announcement-bar--show');
            // Menüposition neu berechnen
            window.dispatchEvent(new Event('resize'));
        }

        // Schließen-Button Funktionalität
        closeButton.addEventListener('click', function() {
            console.log('closeButton clicked');
            announcementBar.classList.remove('announcement-bar--show');
            announcementBar.classList.add('announcement-bar--hidden');
            sessionStorage.setItem('announcementBarClosed', 'true');
        });
    }
}

export default initAnnouncementBar;